import { Component, createResource, For, Show } from "solid-js";
import { A } from "@solidjs/router";
import { api } from "../auth";

const Predictions: Component = () => {
  const [preds] = createResource(
    () => api<{ predictions: any[] }>("/api/predictions?limit=50")
      .catch((e) => ({ predictions: [], error: e.message })),
  );

  return (
    <>
      <h1>Model analysis <span class="muted">— mathematical probability and market comparisons</span></h1>
      <p class="page-intro">These statistical outputs are provided for information and independent analysis. They are not betting advice, gambling advice, sports picks or recommendations.</p>
      <Show when={true}>
        <Show when={preds()?.predictions?.length} fallback={<p class="muted">No analysis yet — the model hasn't scored today's races.</p>}>
          <div class="card" style="padding: 0;">
            <table>
              <thead>
                <tr>
                  <th>Date</th><th>Track</th><th>Race</th><th>Horse</th>
                  <th>p_fund</th><th>p_pub</th><th>p_comb</th><th>Edge</th><th>Model view</th>
                </tr>
              </thead>
              <tbody>
                <For each={preds()!.predictions}>
                  {(p: any) => (
                    <tr>
                      <td>{p.date}</td>
                      <td>{p.track_id}</td>
                      <td><A href={`/races/${p.race_id}`}>{p.race_id.split('-').slice(-1)[0]}</A></td>
                      <td>{p.horse_id}</td>
                      <td>{p.prob_fund?.toFixed(3)}</td>
                      <td>{p.prob_pub?.toFixed(3)}</td>
                      <td>{p.prob_comb?.toFixed(3)}</td>
                      <td class="pos-1">{p.edge ? `${(p.edge * 100).toFixed(1)}%` : "—"}</td>
                      <td><span class="badge">{p.edge > 0.02 ? "Above market" : p.edge < -0.02 ? "Below market" : "Near market"}</span></td>
                    </tr>
                  )}
                </For>
              </tbody>
            </table>
          </div>
        </Show>
      </Show>
    </>
  );
};

export default Predictions;
